import timeEntryUtils from "@/src/shared/utils/timeEntry";
import { TimeInputs, TimeParts } from "../types/easyTimePicker";

class EasyTimePickerUtils {
  validateTimePart(updateValue: string, pressedKey: string | null, max: number) {
    if (this._isEmptyOrNaN(updateValue)) return "";
    if (updateValue === "00") return "00";
    if (updateValue === "0" && !pressedKey) return updateValue.slice(0, -1);
    if (this._shouldPadZero(updateValue, pressedKey)) return timeEntryUtils.padTimePart(updateValue);

    return this._clampValue(updateValue, max);
  }

  _shouldPadZero(value: string, pressedKey: string | null) {
    return pressedKey !== "0" && value.startsWith("0") && value.length < 3;
  }
  _clampValue(value: string, max: number) {
    return String(Math.max(0, Math.min(max, +value)));
  }

  _isEmptyOrNaN(value: string) {
    return value === "" || isNaN(+value);
  }

  validateMeridiem(updatedMeridiem: string) {
    const input = updatedMeridiem.toLowerCase();
    if (input.length === 1) {
      return ["a", "p"].includes(input) ? input : "";
    }

    if (input.length === 2) {
      return input.endsWith("m") ? input : input[0];
    }

    return input.slice(0, 2);
  }

  formatHours(hours: string, meridiem: string, useMeridiem: boolean) {
    if (!hours) return "";
    if (useMeridiem) {
      const formattedHour = meridiem.startsWith("p") && +hours < 12 ? +hours + 12 : +hours;
      return timeEntryUtils.padTimePart(formattedHour);
    }

    return timeEntryUtils.padTimePart(hours);
  }

  formatMinutes(minutes: string) {
    if (!minutes) return "";

    return timeEntryUtils.padTimePart(minutes);
  }

  formatTimeToHHmm(timeInputValues: TimeInputs, useMeridiem: boolean) {
    const hourFormatted = this.formatHours(
      timeInputValues[TimeParts.Hours],
      timeInputValues[TimeParts.Meridiem],
      useMeridiem
    );

    if (!timeInputValues[TimeParts.Minutes]) return "";
    const minuteFormatted = this.formatMinutes(timeInputValues[TimeParts.Minutes]);

    return `${hourFormatted}:${minuteFormatted}`;
  }
}

export default new EasyTimePickerUtils();
